/**
 * Author: Codex
 * GameApp - Unified Phaser entry powered by GameManager
 * Purpose: Make GameManager + GameContainer the single source of truth.
 * Version: v3.2.140
 * Modified: 2025-10-17 - Fixed GameManager import (default → named import)
 */
import React, { useEffect } from 'react';
import { getGameManager } from '@game/GameManager';

export const GameApp: React.FC = () => {
  useEffect(() => {
    let mounted = true;

    // Enable game mode (disable body scroll)
    document.body.classList.add('game-mode');

    const boot = async () => {
      try {
        const gm = getGameManager();
        await gm.initialize();
        if (mounted) {
          gm.start();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to start GameManager:', err);
      }
    };

    boot();

    return () => {
      mounted = false;

      // Disable game mode (restore body scroll)
      document.body.classList.remove('game-mode');

      try {
        const gm = getGameManager();
        gm.destroy();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('Error during GameManager destroy:', err);
      }
    };
  }, []);

  // IMPORTANT: The id must match GAME_CONFIG.parent (phaser-game)
  return (
    <div className="w-full h-screen bg-black flex items-center justify-center">
      <div id="phaser-game" />
    </div>
  );
};

export default GameApp;

